export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.66c33e43.svg";